import $ from 'jquery'
import { Core } from './core'

export class ListEnhancer {
  constructor () {
    if (Core.isAdmin()) return

    this.$body = $('body')

    this.injectChecklistIcons()
  }

  injectChecklistIcons () {
    const $lists = $('.checklist-boxed')
    if (!$lists.length) return

    const checkmarkSvg = `
<svg class="icon icon-bim-checkmark-square-02 icon-wysiwyg" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.057 2.25C14.248 2.25 15.969 2.25001 17.312 2.43101C18.689 2.61601 19.781 3.00301 20.639 3.86101C21.497 4.71901 21.884 5.81099 22.069 7.18799C22.25 8.53099 22.25 10.252 22.25 12.443V12.557C22.25 14.748 22.25 16.469 22.069 17.812C21.884 19.189 21.497 20.281 20.639 21.139C19.781 21.997 18.689 22.384 17.312 22.569C15.969 22.75 14.248 22.75 12.057 22.75H11.943C9.75199 22.75 8.03099 22.75 6.68799 22.569C5.31099 22.384 4.21901 21.997 3.36101 21.139C2.50301 20.281 2.11601 19.189 1.93101 17.812C1.75001 16.469 1.75 14.748 1.75 12.557V12.443C1.75 10.252 1.75001 8.53099 1.93101 7.18799C2.11601 5.81099 2.50301 4.71901 3.36101 3.86101C4.21901 3.00301 5.31099 2.61601 6.68799 2.43101C8.03099 2.25001 9.75199 2.25 11.943 2.25H12.057ZM16.676 8.76299C17.083 9.13599 17.11 9.769 16.737 10.176L11.237 16.176C11.053 16.377 10.794 16.494 10.522 16.5C10.249 16.506 9.98599 16.4 9.79299 16.207L7.29299 13.707C6.90199 13.317 6.90199 12.683 7.29299 12.293C7.68299 11.902 8.31701 11.902 8.70701 12.293L10.469 14.054L15.263 8.824C15.636 8.417 16.269 8.38999 16.676 8.76299Z" fill="currentColor"></path>
</svg>`

    const cancelSvg = `
<svg class="icon icon-bim-cancel-square icon-wysiwyg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.0576 1.75C14.2479 1.74999 15.9683 1.75012 17.3115 1.93066C18.6882 2.11575 19.7805 2.50313 20.6387 3.36133C21.4969 4.21953 21.8843 5.31182 22.0693 6.68848C22.2499 8.03174 22.25 9.75212 22.25 11.9424V12.0576C22.25 14.2479 22.2499 15.9683 22.0693 17.3115C21.8843 18.6882 21.4969 19.7805 20.6387 20.6387C19.7805 21.4969 18.6882 21.8843 17.3115 22.0693C15.9683 22.2499 14.2479 22.25 12.0576 22.25H11.9424C9.75212 22.25 8.03174 22.2499 6.68848 22.0693C5.31182 21.8843 4.21953 21.4969 3.36133 20.6387C2.50313 19.7805 2.11575 18.6882 1.93066 17.3115C1.75012 15.9683 1.74999 14.2479 1.75 12.0576V11.9424C1.74999 9.75212 1.75012 8.03174 1.93066 6.68848C2.11575 5.31182 2.50313 4.21953 3.36133 3.36133C4.21953 2.50313 5.31182 2.11575 6.68848 1.93066C8.03174 1.75012 9.75212 1.74999 11.9424 1.75H12.0576ZM15.707 8.29297C15.3165 7.90246 14.6835 7.90247 14.293 8.29297L12 10.5859L9.70703 8.29297C9.31655 7.9027 8.68344 7.90271 8.29297 8.29297C7.90246 8.68351 7.90243 9.3175 8.29297 9.70801L10.5859 12L8.29297 14.292C7.90243 14.6825 7.90246 15.3165 8.29297 15.707C8.68344 16.0973 9.31655 16.0973 9.70703 15.707L12 13.4141L14.293 15.707C14.6835 16.0975 15.3165 16.0975 15.707 15.707C16.0975 15.3165 16.0975 14.6835 15.707 14.293L13.4141 12L15.707 9.70703C16.0975 9.31652 16.0975 8.6835 15.707 8.29297Z" fill="currentColor" />
</svg>`

    $lists.each(function () {
      const $list = $(this)
      $list.find('li').each(function () {
        const $li = $(this)
        if ( $li.hasClass('disable') ) {
          // Eviter de dupliquer si déjà présent
          if (!$li.children('svg.icon-bim-cancel-square').length) {
            $li.prepend(cancelSvg)
          }
        } else {
          // Eviter de dupliquer si déjà présent
          if (!$li.children('svg.icon-bim-checkmark-square-02').length) {
            $li.prepend(checkmarkSvg)
          }
        }
      })
    })
  }
}
